module.exports = __webpack_public_path__ + "media/images/logo_iac-f2300ee0cae254cae007d9587b4b79dc.png";